import*as React from"react";import styled from"@emotion/styled";import{mediaHeightQuery}from"@wp/src/components/common/grid";const PageMainContentLayoutContainer=styled.div`
  & > :not(:last-child) {
    ${mediaHeightQuery({marginBottom:["8px","10px","12px","16px","16px","20px","24px"]})}
  }
`;const PageMainContentLayout=props=>{return React.createElement(PageMainContentLayoutContainer,null,props.children)};export default PageMainContentLayout;